export default __webpack_public_path__ + "static/media/partner-elpis.09f58704.png";